import SsidChartRoundedIcon from '@mui/icons-material/SsidChartRounded';
import { Box, Breadcrumbs, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import Link from 'next/link';
import React from "react";
import { isMobile } from "../../../helpers/deviceDetect";
// import AddAlertRoundedIcon from '@mui/icons-material/AddAlertRounded';
// import Trading_Up from '../../../../src/static/images/page/trading/trending_up.svg'
// import Trading_Down from '../../../../src/static/images/page/trading/trending_down.svg'
// import { convertDate, getTradingItem } from '../../../helpers/time';
// import { roundNum } from '../../../helpers';
// import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  return {
    height: '24px',
    backgroundColor: 'transparent',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      // backgroundColor: 'rgba(23, 76, 134, .1)',
      // cursor: 'pointer',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[1],
      color: theme.palette.text.color.white,
      icon: {
        color: theme.palette.text.link,
      }
    },
    '&:active': {
      boxShadow: theme.shadows[2],
      // backgroundColor: theme.palette.background.primary,
    },
  };
});

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   // textAlign: 'center',
//   color: theme.palette.text.very_light_desc,
//   boxShadow: theme.palette.mode === 'dark' ? 0 : '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
//   border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
// }));


const BreadCrumb = (props) => {
  const { ticker, tab, newStockSumPage } = props || {}
  const [maxItems, setMaxItems] = React.useState(4);

  React.useEffect(() => {
    if (isMobile) {
      setMaxItems(2);
    }
  }, []);

  return (
    <Box component="nav"
      className="bread-container"
      sx={{
        padding: '0 0 8px 0px',
        textAlign: 'right',
        // bgcolor: 'background.paper',
        // boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        // borderRadius: '5px',
        mt: .8,
        "& .chip-home": { pr: 0 }
      }}
      itemScope itemType="http://schema.org/WebPage">
      <Breadcrumbs maxItems={maxItems} itemProp="breadcrumb" separator="›" >
        <Link prefetch={false} color="inherit" href='/stock'>
          <StyledBreadcrumb
            underline="hover"
            label="Stock"
            className="chip-home"
            icon={<SsidChartRoundedIcon sx={{ '&.MuiChip-icon': { color: 'text.very_light_desc' } }} fontSize="small" />}
            sx={{ color: 'text.very_light_desc', fontSize: '.78rem' }}
          />
        </Link>
        <Link prefetch={false} color="inherit" href={`/stock/${ticker}`}>
          <StyledBreadcrumb
            label={`${ticker}`}
            className={'bread-bg-blue'}
            sx={{ color: 'text.very_light_desc', fontSize: '.78rem' }}
          />
        </Link>
        {tab &&
          <StyledBreadcrumb
            // component="a"
            itemProp="name"
            label={tab}
            sx={{
              backgroundColor: '#f2f2f2', fontSize: '.78rem'
            }}
          />}
      </Breadcrumbs>
    </Box>
  )
}

export default React.memo(BreadCrumb)
